import { useCallback, useEffect } from 'react';
import { fabric } from 'fabric';

function useCanvasSizeChange(canvasEl: Nullable<fabric.Canvas>, sizeChangeHandler: (canvasWidth: number, canvasHeight: number) => void, id: string) {
  const getCanvasSize = useCallback(() => {
    const canvasContainer = document.getElementById(id);
    if (canvasContainer) {
      return {
        canvasWidth: canvasContainer.clientWidth,
        canvasHeight: canvasContainer.clientHeight
      };
    }
    return {
      canvasWidth: 500,
      canvasHeight: 500
    };
  }, [id]);

  const updateWidth = useCallback(() => {
    const { canvasHeight, canvasWidth } = getCanvasSize();
    if (canvasEl) {
      canvasEl.setWidth(canvasWidth);
      canvasEl.setHeight(canvasHeight);
      sizeChangeHandler(canvasWidth, canvasHeight);
    }
  }, [canvasEl, getCanvasSize, sizeChangeHandler]);

  useEffect(() => {
    updateWidth();
  }, [updateWidth]);

  useEffect(() => {
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, [updateWidth]);
}

export default useCanvasSizeChange;
